export default __webpack_public_path__ + "static/media/Linkedin Learning CSS Essential Training.dd8ef895.webp";